var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStargate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FAFAFA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,18.3c0.4,0.4,0.9,0.6,1.5,0.6l27.5,0v3.8c0,0.8,0.6,1.6,1.3,1.9c0.8,0.3,1.7,0.1,2.2-0.5l9.1-9.2 c1.1-1.1,1.1-2.8,0-3.9l-9.1-9.1c-0.6-0.6-1.5-0.8-2.2-0.4c-0.8,0.3-1.3,1.1-1.3,1.9l0,3.8l-27.5,0c-1.1,0-2.1,0.9-2.1,2.1l0,7.5 C3.5,17.4,3.7,17.9,4.1,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,29.2l-27.5,0l0-3.8c0-0.8-0.5-1.6-1.3-1.9c-0.8-0.3-1.7-0.1-2.2,0.4L4.3,33c-1.1,1.1-1.1,2.8,0,3.9 l9.1,9.2c0.6,0.6,1.5,0.8,2.2,0.5c0.8-0.3,1.3-1.1,1.3-1.9v-3.8l27.5,0c0.5,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5l0-7.5 C46.5,30.2,45.6,29.2,44.5,29.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargate);
export default __webpack_public_path__ + "static/media/stargate.acb41d70b33b4335965774b29a895f8e.svg";
export { ForwardRef as ReactComponent };